import { moduleProviderFactory } from 'core/providers';
import { SellerList, SellerEdit } from 'modules/seller/pages';
import { isSellerOrganization } from 'core/utils';

// Sellers reach this section to maintain their own organization; the backend scopes what they see to it.
const sellerSectionAuthorization = rootStore =>
	rootStore.authStore.hasPermission('platformSection.full') || isSellerOrganization(rootStore);

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.seller',
				pattern: '/sellers',
				isPrivate: true,
				authorization: sellerSectionAuthorization,
				children: [
					{
						name: 'master.app.main.seller.list',
						pattern: '',
						component: SellerList,
					},
					{
						name: 'master.app.main.seller.create',
						pattern: '/create',
						component: SellerEdit,
						authorization: ['platformSection.full'],
					},
					{
						name: 'master.app.main.seller.edit',
						pattern: '/edit/:id',
						component: SellerEdit,
					},
				],
			},
		],
	});
})();
